/**
 * This servers as way to get access to a feature flags assigned to user
 *
 * This data is not specific to a character, although its use may sometimes be.
 *
 * We are hoping to get this moved to its own service at some point. Or a more
 * more global service.
 *
 */
import React, { useMemo } from 'react';
import { useEffect } from 'react';

import { Constants, FeatureFlagInfo, FeatureFlagManager } from '@dndbeyond/character-rules-engine/es';

export interface FeatureFlagContextProviderProps {
    children: React.ReactNode;
    featureFlagInfo: FeatureFlagInfo;
}

export const FeatureFlagContext = React.createContext<FeatureFlagManager>(
    new FeatureFlagManager(Constants.DEFAULT_FEATURE_FLAG_INFO),
);

export function FeatureFlagContextProvider({ children, featureFlagInfo }: FeatureFlagContextProviderProps) {
    const featureFlagManager = useMemo(() => new FeatureFlagManager(featureFlagInfo), []);
    useEffect(() => {
        featureFlagManager.update(featureFlagInfo);
    }, [featureFlagInfo]);

    return <FeatureFlagContext.Provider value={featureFlagManager}>{children}</FeatureFlagContext.Provider>;
}
